import { Navigate, Outlet } from "react-router-dom";
import { getToken } from "./adminApi";

export default function RequireAdmin() {
  if (!getToken()) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}
